<template>
    <div class="welcome orange">
        <div class="mycontent">
          <div class="row">
            <div class="vAligner">
              <div class="large-5 medium-12 small-12 columns">
                  <img :src="`${ Content.logo }`" class="welcome-logo">
                  <h1>{{  Content.main }}</h1>
                  <p>{{  Content.sub }} </p>
                </div>
              <div class="large-6 medium-12 small-12 columns"><img :src="`${Content.img}`" alt="Christina Aguilera and Latto" class="welcome-dish" data-aos="fade-up" data-aos-delay="0" data-aos-offset="0"></div>
            </div>
          </div>
        </div>
      </div>
</template>

<script>
let lang = process.env.VUE_APP_LOCALITY;
import Content from "../data/content";

export default {
    name: 'Hero',
    data: function() {
        return {
          Content: Content[lang].hero,
        }
    }
}
</script>

<style lang="scss">
.welcome {
  z-index: 0;
  position: relative;
  top: -1px;
  display: block;
  margin: 0 auto;
  padding: 70px 0 0 0;
  overflow: hidden;
}
.welcome .vAligner {
  justify-content: space-between;
}
.welcome .mycontent {
  position: relative;
}
.welcome h1 {
  color: #fff;
  text-align: left;
  font-family: 'jet-extrablack';
  font-size: 54px;
  text-align: center;
  line-height: 60px;
  max-widtH: 700px;
  margin: 0 auto;
}
.welcome .columns img {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.welcome-logo {
  width: 100%;
  margin-bottom: 40px;
  max-width: 260px;
}
.welcome-dish {
  z-index: -1;
  position: relative;
  bottom: 0;
  left: 0;
  height: auto;
  max-width: none;
  width: 100%;
}
.welcome p {
  max-width: 100%;
  margin: 30px 0 175px;
  color: #fff;
  font-size: 32px;
  line-height: 42px;
  text-align: center;
  font-family: 'jet-extrabold';
}

.welcome .columns:last-of-type {
  align-self: end;
}

</style>